import type { TOC } from '@ember/component/template-only'
import type { LexileDetailsRexRoute } from 'teacher-ui-client/reporting/ui-scope/rex/lexile-details/route'
import { t } from 'ember-intl'
import { array } from '@ember/helper'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import ReportingTeacherUiHeader from 'teacher-ui-client/components/reporting/teacher-ui-header'
import fullGradeName from 'teacher-ui-client/helpers/full-grade-name'
import ReportingDetailedControls from 'teacher-ui-client/components/reporting/detailed-controls'
import ReportingNoDataMessageIf from 'teacher-ui-client/components/reporting/no-data-message-if'
import { not } from 'ember-truth-helpers'
import isSubco from 'teacher-ui-client/helpers/is-subco'
import RouteTemplate from 'ember-route-template'
import { LexileDetailsHistory } from 'teacher-ui-client/components/giraffe/charts/lexile-details/history'
import { LexileDetailsAverages } from 'teacher-ui-client/components/giraffe/charts/lexile-details/averages'

interface Signature {
  model: ModelFor<LexileDetailsRexRoute>
}

export const RexLexileDetails: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.lexileDetails"}} />
  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{Boolean @model.lexileDetailsAverages}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.rex.student-summary"
  />
  <ReportingNoDataMessageIf @on={{not @model.lexileDetailsAverages}}>
    {{#each @model.lexileDetailsAverages as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <LexileDetailsAverages
          @data={{gradeData}}
          @tooltip={{t "reporting.tooltips.lexileDetailsAverages"}}
          @title={{t "reporting.chartTitles.lexileDetailsAverages"}}
          @product={{@model.product}}
          @grade={{fullGradeName gradeData.grade_position}}
        />
      </div>
    {{/each}}
    {{#if @model.lexileDetailsHistory}}
      <div class="my-10">
        <LexileDetailsHistory
          @lexileDetailsData={{@model.lexileDetailsHistory}}
          @students={{@model.scopedStudents}}
          @subco={{(isSubco)}}
          @uiScope={{@model.uiScope.scope}}
          @tooltip={{t "reporting.tooltips.lexileDetailsHistory"}}
          @product={{@model.product}}
        />
      </div>
    {{/if}}
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(RexLexileDetails)
